/* Nova Thera theme.js — no dependencies */
(() => {
  const NT = window.NovaTheme || { routes: {}, strings: {}, cartMode: 'upcart' };
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => Array.from(el.querySelectorAll(s));

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(msg) {
    const el = $('[data-toast]');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { el.hidden = true; }, 3200);
  }

  /* ---------- Header shadow on scroll ---------- */
  const header = $('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Announcement rotation ---------- */
  $$('[data-announcement]').forEach((bar) => {
    const slides = $$('.announcement__slide', bar);
    if (slides.length < 2) return;
    const interval = parseInt(bar.dataset.interval, 10) || 4000;
    let i = 0;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;
    setInterval(() => {
      slides[i].classList.remove('is-active');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-active');
    }, interval);
  });

  /* ---------- Drawer (mobile menu) ---------- */
  let lastFocus = null;
  function openDrawer(drawer) {
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    $$(`[aria-controls="${drawer.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'true'));
    const focusable = $('a, button', $('.drawer__panel', drawer));
    if (focusable) focusable.focus();
  }
  function closeDrawer(drawer) {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    $$(`[aria-controls="${drawer.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'false'));
    if (lastFocus) lastFocus.focus();
  }
  $$('[data-drawer-open]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const d = document.getElementById(btn.dataset.drawerOpen);
      if (d) openDrawer(d);
    });
  });
  $$('[data-drawer]').forEach((drawer) => {
    $$('[data-drawer-close]', drawer).forEach((el) => el.addEventListener('click', () => closeDrawer(drawer)));
    drawer.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(drawer); });
  });

  /* ---------- Cart count ---------- */
  async function refreshCartCount() {
    try {
      const res = await fetch(`${NT.routes.cart_url}.js`, { headers: { Accept: 'application/json' } });
      const cart = await res.json();
      $$('[data-cart-count]').forEach((el) => {
        el.dataset.count = cart.item_count;
        el.textContent = cart.item_count > 0 ? cart.item_count : '';
      });
      return cart;
    } catch (e) { return null; }
  }

  /* ---------- Add to cart (Upcart aware) ---------- */
  function openCart() {
    if (NT.cartMode === 'page') { window.location.href = NT.routes.cart_url; return; }
    if (typeof window.upcartRefreshCart === 'function') { try { window.upcartRefreshCart(); } catch (e) {} }
    if (typeof window.upcartOpenCart === 'function') { try { window.upcartOpenCart(); return; } catch (e) {} }
    // Upcart not present: fall back to the cart page.
    window.location.href = NT.routes.cart_url;
  }

  // Free gifts: products can declare gift variants (see snippets/review-float.liquid).
  // The gifts are sent in the SAME add request as the main item, so cart drawers
  // (Upcart) that open on the add response show everything at once.
  async function giftItemsFor(form) {
    const cfgEl = document.querySelector('[data-gift-config]');
    if (!cfgEl) return [];
    let cfg; try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return []; }
    if (cfg.form && form.id !== cfg.form) return [];
    let inCart = new Set();
    try {
      const cart = await (await fetch(`${NT.routes.cart_url}.js`, { headers: { Accept: 'application/json' } })).json();
      inCart = new Set(cart.items.map((i) => i.variant_id));
    } catch (e) {}
    return cfg.variants.filter((id) => !inCart.has(id)).map((id) => ({ id, quantity: 1, properties: { _gift: cfg.label || 'Free gift' } }));
  }
  function itemFromForm(form) {
    const fd = new FormData(form);
    const item = { id: Number(fd.get('id')), quantity: Number(fd.get('quantity')) || 1 };
    if (fd.get('selling_plan')) item.selling_plan = Number(fd.get('selling_plan'));
    const props = {};
    for (const [k, v] of fd.entries()) { const m = k.match(/^properties\[(.+)\]$/); if (m && v !== '') props[m[1]] = v; }
    if (Object.keys(props).length) item.properties = props;
    return item;
  }

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    if (NT.cartMode === 'page' && !form.hasAttribute('data-force-ajax')) return; // native POST to /cart/add
    e.preventDefault();
    const button = $('[type="submit"]', form);
    const label = button ? ($('[data-add-label]', button) || button) : null;
    const original = label ? label.innerHTML : '';
    if (button) { button.setAttribute('aria-busy', 'true'); button.disabled = true; }
    if (label && label.hasAttribute('data-add-label')) label.textContent = NT.strings.adding || 'Adding…';
    try {
      const gifts = await giftItemsFor(form);
      const res = gifts.length
        ? await fetch(`${NT.routes.cart_add_url}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ items: [itemFromForm(form), ...gifts] })
          })
        : await fetch(`${NT.routes.cart_add_url}.js`, {
            method: 'POST',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: new FormData(form)
          });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || NT.strings.error);
      await refreshCartCount();
      document.dispatchEvent(new CustomEvent('nova:cart:added', { detail: data }));
      openCart();
    } catch (err) {
      toast(err.message || NT.strings.error || 'Something went wrong. Try again.');
    } finally {
      if (button) { button.removeAttribute('aria-busy'); button.disabled = false; }
      if (label) label.innerHTML = original;
    }
  });

  /* ---------- Quantity ---------- */
  $$('[data-qty]').forEach((qty) => {
    const input = $('input', qty);
    $('[data-qty-minus]', qty)?.addEventListener('click', () => { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
    $('[data-qty-plus]', qty)?.addEventListener('click', () => { input.value = (parseInt(input.value, 10) || 1) + 1; });
  });

  /* ---------- Product gallery ---------- */
  $$('[data-gallery]').forEach((gallery) => {
    const track = $('[data-gallery-slides]', gallery);
    if (!track) return;
    const slides = $$('.gallery__slide', track);
    const thumbs = $$('[data-thumb]', gallery);
    const dots = $$('.gallery__dots span', gallery);
    let index = 0;

    const setActive = (i) => {
      index = i;
      thumbs.forEach((t, n) => t.setAttribute('aria-current', n === i ? 'true' : 'false'));
      dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
    };
    const goTo = (i, smooth = true) => {
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
      setActive(i);
    };
    thumbs.forEach((t, i) => t.addEventListener('click', () => goTo(i)));
    $('[data-gallery-prev]', gallery)?.addEventListener('click', () => goTo(index - 1));
    $('[data-gallery-next]', gallery)?.addEventListener('click', () => goTo(index + 1));

    let raf;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== index) setActive(i);
      });
    }, { passive: true });

    gallery.goToMedia = (mediaId) => {
      const i = slides.findIndex((s) => s.dataset.mediaId === String(mediaId));
      if (i > -1) goTo(i);
    };
  });

  /* ---------- Variant picker ---------- */
  $$('[data-product-section]').forEach((section) => {
    const picker = $('[data-variant-picker]', section);
    if (!picker) return;
    const variants = JSON.parse($('[data-variants]', picker).textContent);
    let variantMedia = {};
    try { variantMedia = JSON.parse(($('[data-variant-media]', picker) || {}).textContent || '{}'); } catch (e) {}
    const form = $('[data-product-form]', section);
    const idInput = form ? $('[data-variant-id]', form) : null;
    const gallery = $('[data-gallery]', section);
    const sectionId = section.dataset.sectionId;

    const selected = () => $$('fieldset', picker).map((fs) => {
      const checked = $('input:checked', fs);
      return checked ? checked.value : null;
    });

    const markAvailability = (current) => {
      $$('fieldset', picker).forEach((fs, optIndex) => {
        $$('input', fs).forEach((input) => {
          const opts = current.slice();
          opts[optIndex] = input.value;
          const match = variants.find((v) => v.options.every((o, n) => o === opts[n]));
          input.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
    };

    const update = async () => {
      const opts = selected();
      $$('[data-option-value]', picker).forEach((el, n) => { el.textContent = opts[n]; });
      markAvailability(opts);
      const variant = variants.find((v) => v.options.every((o, n) => o === opts[n]));
      const addBtn = $('[data-add-button]', section);
      const addLabel = $('[data-add-label]', section);
      const stickyBtn = $('[data-sticky-add]');
      if (!variant) {
        if (addBtn) addBtn.disabled = true;
        if (addLabel) addLabel.textContent = NT.strings.unavailable;
        if (stickyBtn) { stickyBtn.disabled = true; stickyBtn.textContent = NT.strings.unavailable; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
      const mediaId = variantMedia[variant.id] || (variant.featured_media && variant.featured_media.id);
      if (mediaId && gallery && gallery.goToMedia) gallery.goToMedia(mediaId);

      const label = variant.available ? NT.strings.addToCart : NT.strings.soldOut;
      if (addBtn) addBtn.disabled = !variant.available;
      if (addLabel) addLabel.textContent = label;
      if (stickyBtn) { stickyBtn.disabled = !variant.available; stickyBtn.textContent = label; }

      // Refresh server-rendered price, savings and stock for exact money formatting.
      try {
        const res = await fetch(`${url.pathname}?variant=${variant.id}&section_id=${sectionId}`);
        const html = new DOMParser().parseFromString(await res.text(), 'text/html');
        const swap = (sel) => {
          const fresh = $$(sel, html);
          $$(sel, document).forEach((el, n) => { if (fresh[n]) el.replaceWith(fresh[n]); });
        };
        swap('[data-product-info] [data-price]');
        swap('.sticky-atc [data-price]');
        swap('[data-stock]');
      } catch (e) { /* keep current price on network error */ }
    };

    picker.addEventListener('change', update);
    markAvailability(selected());
  });

  /* ---------- Sticky add to cart ---------- */
  const sticky = $('[data-sticky-atc]');
  const mainAdd = $('[data-add-button]');
  if (sticky && mainAdd && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(([entry]) => {
      const past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', past);
      sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
      $('[data-sticky-add]', sticky).tabIndex = past ? 0 : -1;
    });
    io.observe(mainAdd);
    $('[data-sticky-add]', sticky).addEventListener('click', () => {
      const form = mainAdd.closest('form');
      if (form) form.requestSubmit ? form.requestSubmit(mainAdd) : mainAdd.click();
    });
  }

  /* ---------- Product recommendations ---------- */
  $$('[data-recommendations]').forEach(async (el) => {
    if (el.children.length > 0) return;
    try {
      const res = await fetch(el.dataset.url);
      const html = new DOMParser().parseFromString(await res.text(), 'text/html');
      const fresh = $('[data-recommendations]', html);
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
      else el.closest('section')?.remove();
    } catch (e) { el.closest('section')?.remove(); }
  });

  /* ---------- Collection sorting ---------- */
  $$('[data-sort-select]').forEach((select) => {
    select.addEventListener('change', () => select.form.submit());
  });

  /* ---------- Login: password recovery toggle ---------- */
  $$('[data-toggle-recover]').forEach((a) => a.addEventListener('click', () => {
    const r = document.getElementById('recover');
    if (r) r.scrollIntoView({ behavior: 'smooth' });
  }));
})();
